import { useEffect } from 'react'

import {
  MAX_RETRY,
  normalizeMultipleMovementStatuses,
  useMovementStatusState
} from './helpers/use-movement-status-state'
import { useFetchMovementStatus } from './use-fetch-movement-status'

export function useCheckMovementStatus({
  accountId,
  bucketId,
  movementIds
}: {
  accountId: string
  bucketId: string
  movementIds?: string[]
}) {
  const { status, setStatus, shouldCheckStatus, handleError, handleSuccess, reset } = useMovementStatusState()

  const { isMovementStatusLoading } = useFetchMovementStatus({
    accountId,
    bucketId,
    movementIds,
    config: {
      enabled: Boolean(accountId && bucketId && !!movementIds?.length && shouldCheckStatus),
      refetchInterval: 1000,
      retry: MAX_RETRY + 1,
      onError: handleError,
      onSuccess: response => {
        const movementStatuses = Object.keys(response.movementIds).map(key => response.movementIds[key])
        handleSuccess(normalizeMultipleMovementStatuses(movementStatuses))
      }
    }
  })

  useEffect(() => {
    if (isMovementStatusLoading && status !== 'loading') {
      setStatus('loading')
    }
  }, [isMovementStatusLoading, status, setStatus])

  return { reset, status }
}
